import { Navigate, Outlet } from "react-router-dom"
import { useBusinessOperationalAccess } from "@/hooks/use-business-operational-access"
import { AppBootstrapLoader } from "@/components/loaders/preloader"

export function BusinessOperationalGuard() {
  const { canUseOperationalFeatures, isLoading } = useBusinessOperationalAccess()

  if (isLoading) {
    return <AppBootstrapLoader />
  }

  if (!canUseOperationalFeatures) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}

export default BusinessOperationalGuard
